export default {
  title: "Balance",
  descriptionDefault: "Track your earnings and transactions",
  descriptionFull: "Track all transactions for your activities",
  hostIdMissing: "Host user ID not found",
  salesAgentIdMissing: "Sales agent user ID not found",
  sellerIdMissing: "Seller user ID not found",
  loadingBalance: "Loading balance data...",
  errorLoad: "Error loading wallet data",
  statCurrentBalance: "Current balance",
  statAmountOwed: "Amount owed",
  statTotalIncome: "Total Income (Period)",
  statTotalExpenses: "Total Expenses (Period)",
  statTransactions: "Transactions (Period)",
  filtersTitle: "Search Filters",
  filtersActive_one: "{{count}} filter active",
  filtersActive_other: "{{count}} filters active",
  filtersHint: "Set filters to narrow down results",
  dateRange: "Date Range",
  from: "From",
  to: "To",
  searchCriteria: "Search Criteria",
  searchDescriptionLabel: "Search in Description",
  searchDescriptionPlaceholder: "Search transactions...",
  activityLabel: "Activity",
  allActivities: "All Activities",
  amountRange: "Amount Range",
  minAmount: "Minimum Amount (€)",
  maxAmount: "Maximum Amount (€)",
  placeholderMin: "0.00",
  placeholderMax: "No limit",
  clearFilters: "Clear All Filters",
  applyFilters: "Apply New Filters",
  searchTransactions: "Search Transactions",
  unsavedFilters:
    'You have unsaved filter changes. Click "Apply New Filters" to search.',
  transactionsTitle: "Transactions",
  results_one: "{{count}} result",
  results_other: "{{count}} results",
  loadingTransactions: "Loading transactions...",
  emptyTitle: "No transactions found",
  emptyDescFiltered: "Try adjusting your filters",
  emptyDescDefault: "Your transactions will appear here",
} as const;
